module.exports = __webpack_public_path__ + "img/icons8-checked.862c1e9e.png";